<script setup lang="ts">
import PropertyTypeValueFactory from '@toolify/client/src/modules/databases/factories/PropertyTypeValueFactory.vue'
import {PropertyValueType} from '@toolify/server/src/services/DatabasePropertyService/types/PropertyValueType'

interface Props {
  valueType: PropertyValueType
  valuePayload: unknown
  createdAt: Date
}

const props = defineProps<Props>()
</script>

<template>
  <div class="database-item-value" :class="`type-${valueType}`">
    <PropertyTypeValueFactory
      :valueType="valueType"
      :valuePayload="valuePayload"
      :isInEditMode="false"
      :isFocused="false"
      :relativeToDate="createdAt"
      :valueListeners="{}"
    />
  </div>
</template>

<style scoped lang="scss">
  @use '../../../styles/variables' as variables;

  .database-item-value {
    display: flex;
    height: 100%;
    align-items: center;
    justify-content: start;
    border-radius: variables.$borderRadius;
    pointer-events: none;
    position: relative;
    max-height: 100%;
    color:map-get(variables.$colors, content-light);

    :deep(.status.type-secondary) {
      height: auto;
    }
  }

  .type-status{
    &:deep(.status-item-value-strategy){
      min-height: map-get(variables.$sizes, size-xs);
    }
    &:deep(.status){
      padding: 0 map-get(variables.$spacing, space-1);
    }

  }

  .type-dropdown{
    &:deep(.value){
      gap: map-get(variables.$spacing, space-0-5);
    }
    &:deep(.label){
      height: map-get(variables.$sizes, size-xs);
      padding: map-get(variables.$spacing, space-1) map-get(variables.$spacing, space-2);
      span{
        line-height: 100%;
      }
    }

  }
</style>
